{
  "name": "langwatch",
  "version": "0.33.2",
  "description": "LangWatch TypeScript/JavaScript SDK. Interact with the full LangWatch API and use the LangWatch OpenTelemetry SDK to instrument your application. For more information, see https://docs.langwatch.ai/integration/typescript/guide",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "author": "LangWatch",
  "license": "MIT",
  "engines": {
    "node": ">=20",
    "pnpm": ">=8"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "bin": {
    "langwatch": "./dist/cli/index.js"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./observability": {
      "types": "./dist/observability-sdk/index.d.ts",
      "require": "./dist/observability-sdk/index.js",
      "import": "./dist/observability-sdk/index.mjs"
    },
    "./observability/node": {
      "types": "./dist/observability-sdk/setup/node/index.d.ts",
      "require": "./dist/observability-sdk/setup/node/index.js",
      "import": "./dist/observability-sdk/setup/node/index.mjs"
    },
    "./observability/instrumentation/langchain": {
      "types": "./dist/observability-sdk/instrumentation/langchain/index.d.ts",
      "require": "./dist/observability-sdk/instrumentation/langchain/index.js",
      "import": "./dist/observability-sdk/instrumentation/langchain/index.mjs"
    }
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/langwatch/langwatch.git",
    "directory": "typescript-sdk"
  },
  "scripts": {
    "prepare": "pnpm run generate:server-types && pnpm run generate:openapi-types",
    "cli": "node dist/cli/index.js",
    "lint": "eslint .",
    "test": "vitest",
    "test:unit": "vitest run --exclude '**/*.integration.test.ts'",
    "test:e2e": "dotenv -- vitest run -c ./vitest.e2e.config.mts",
    "test:governance-e2e": "vitest run -c ./vitest.governance-e2e.config.mts",
    "test:seed": "dotenv -e .env.test -- bash -c 'cd ../langwatch && pnpm prisma:seed'",
    "prebuild": "pnpm run prepare",
    "build": "tsc --noEmit && tsup",
    "tarball": "pnpm build && pnpm pack",
    "typecheck": "tsc --noEmit",
    "prepublish": "pnpm run build",
    "generate:openapi-types": "pnpx openapi-typescript ../langwatch/src/app/api/openapiLangWatch.json -o ./src/internal/generated/openapi/api-client.ts",
    "generate:server-types": "./copy-types.sh"
  },
  "devDependencies": {
    "@eslint/js": "^9.32.0",
    "@langchain/core": ">=0.3.68 <0.4.0",
    "@langchain/langgraph": ">=0.4.0 <1.0.0",
    "@langchain/openai": ">=0.6.0 <1.0.0",
    "@opentelemetry/sdk-node": "0.216.0",
    "@opentelemetry/sdk-trace-node": "^2.0.1",
    "@opentelemetry/sdk-trace-web": ">=2.0.1",
    "@types/debug": "^4.1.12",
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^24.1.0",
    "@typescript/native-preview": "7.0.0-dev.20260426.1",
    "@vercel/otel": "^1.13.0",
    "@vitest/coverage-v8": "^4.1.0",
    "dotenv-cli": "^11.0.0",
    "esbuild": "^0.27.3",
    "eslint": "^9.32.0",
    "fets": "^0.8.5",
    "fishery": "^2.3.1",
    "langchain": ">=0.3.0 <2.0.0",
    "msw": "^2.10.4",
    "nock": "^14.0.8",
    "openapi-msw": "^1.2.0",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2",
    "typescript-eslint": "^8.38.0",
    "vitest": "^4.1.0",
    "vitest-mock-extended": "^3.1.0",
    "yaml": "^2.8.1",
    "@opentelemetry/api": "^1.9.0"
  },
  "dependencies": {
    "@opentelemetry/api-logs": "0.205.0",
    "@opentelemetry/core": "^2.0.1",
    "@opentelemetry/exporter-logs-otlp-http": "0.216.0",
    "@opentelemetry/exporter-trace-otlp-http": "0.205.0",
    "@opentelemetry/instrumentation": "0.218.0",
    "@opentelemetry/resources": "^2.0.1",
    "@opentelemetry/sdk-logs": "0.205.0",
    "@opentelemetry/sdk-metrics": "^2.0.1",
    "@opentelemetry/sdk-trace-base": "^2.0.1",
    "@opentelemetry/semantic-conventions": "^1.36.0",
    "@types/prompts": "^2.4.9",
    "chalk": "^4.1.2",
    "commander": "^12.0.0",
    "dotenv": "^17.3.1",
    "js-yaml": "^4.1.0",
    "liquidjs": "^10.27.0",
    "open": "^11.0.0",
    "openapi-fetch": "^0.16.0",
    "ora": "^9.3.0",
    "prompts": "^2.4.2",
    "xksuid": "^0.0.4",
    "zod": "^4.0.14"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.9.0",
    "@ai-sdk/openai": ">=2.0.0 <4.0.0",
    "@langchain/core": ">=0.3.0 <2.0.0",
    "@langchain/langgraph": ">=0.4.0 <2.0.0",
    "@langchain/openai": ">=0.6.0 <2.0.0",
    "@opentelemetry/context-async-hooks": "^2.1.0",
    "@opentelemetry/context-zone": ">=1.19.0 <3.0.0",
    "@opentelemetry/sdk-node": ">=0.200.0 <1.0.0",
    "@opentelemetry/sdk-trace-web": ">=1.19.0 <3.0.0",
    "langchain": ">=0.3.0 <2.0.0"
  },
  "peerDependenciesMeta": {
    "@ai-sdk/openai": {
      "optional": true
    },
    "@langchain/core": {
      "optional": true
    },
    "@langchain/langgraph": {
      "optional": true
    },
    "@langchain/openai": {
      "optional": true
    },
    "@opentelemetry/context-async-hooks": {
      "optional": true
    },
    "@opentelemetry/context-zone": {
      "optional": true
    },
    "@opentelemetry/sdk-node": {
      "optional": true
    },
    "@opentelemetry/sdk-trace-web": {
      "optional": true
    },
    "langchain": {
      "optional": true
    }
  },
  "pnpm": {
    "overrides": {
      "@opentelemetry/api": "^1.9.0",
      "@opentelemetry/core": "^2.0.1",
      "@opentelemetry/resources": "^2.0.1",
      "@opentelemetry/sdk-trace-base": "^2.0.1",
      "@opentelemetry/instrumentation": "0.218.0",
      "@opentelemetry/sdk-node": "0.216.0",
      "@opentelemetry/context-async-hooks": "^2.1.0",
      "@opentelemetry/api-logs": "0.205.0",
      "@opentelemetry/sdk-logs": "0.205.0",
      "@opentelemetry/exporter-logs-otlp-http": "0.216.0",
      "@opentelemetry/exporter-trace-otlp-http": "0.205.0",
      "zod": "^4.0.14",
      "langchain@<0.3.37": "0.3.37",
      "@langchain/core@<0.3.80": "0.3.80",
      "langsmith@<0.6.0": "0.6.0",
      "protobufjs@<7.5.6": ">=7.5.6",
      "protobufjs@>=8.0.0 <8.6.0": ">=8.6.0",
      "uuid@<11.1.1": ">=11.1.1 <12",
      "postcss@<8.5.10": ">=8.5.10",
      "qs@>=6.11.1 <=6.15.1": ">=6.15.2"
    }
  }
}
